import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UserVM } from "@shared-kernel/application/ports/shared/shared-repository";

export const retrieveUserProfile = createAsyncThunk<UserVM, void, { extra: Partial<Dependencies> }>(
  "users/retrieveUserProfile",
  async (_: void, { extra: { sharedRepository } }) => {
    return sharedRepository!.profile();
  },
);

export const resetRetrieveUserProfile = createAction("users/resetRetrieveUserProfile");
